import { Flex } from 'rebass/styled-components';
import styled from 'styled-components/macro';
import get from 'lodash/get';

import { rem } from '@blueprint/ui';

import { colors } from 'themes';

const activeTertiaryDark = get(colors, 'active.tertiary.dark');
const colorFormElements6 = get(colors, 'formElements.6');

/**
 * ScrollContainer
 * Container with styled scrollbar
 */
export const ScrollContainer = styled(Flex)`
  ::-webkit-scrollbar {
    width: ${rem(10)};
  }

  ::-webkit-scrollbar-track {
    background-color: ${colorFormElements6};
  }

  ::-webkit-scrollbar-thumb {
    background: ${activeTertiaryDark};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${activeTertiaryDark};
  }

  overflow-y: auto;

  /* For Firefox */
  scrollbar-color: ${activeTertiaryDark} ${colorFormElements6};
  scrollbar-width: thin;
`;
